<template>
  <div @click.stop="normalEvent()">
    <div class="goodsAgentPrice">
      <div class="agent-name">
        <div>{{logindata.agentName}}</div>
        <div>ID:{{logindata.agentId}}</div>
      </div>
      <div class="agent-price">
        <div class="agent-price-title">代理固定折扣</div>
        <div class="agent-price-edit">
          <div
            class="agent-price-edit-item"
            v-for="(item,index) in organizations"
            :key="index"
            @click="settingEvent($event)"
          >
            <div class="title" :style="`background-color: ${item.color}`">{{item.name}}</div>
            <div class="show" v-if="showSty!=item.name">
              {{item.discount}}
              <i class="el-icon-edit mainColor edit" @click="showSty=item.name"></i>
            </div>
            <el-input v-model="item.discount" v-else placeholder="请输入折扣">
              <template slot="append">
                <span class="mainColor" @click="updateAgentLevel(item)">保存</span>
                <span style="cursor: pointer;" @click="showSty=''">取消</span>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="agent-goods">
        <div class="agent-goods-title">特殊商品折扣</div>
        <el-button size="small" @click="openaddFormVisible" type="primary">添加商品</el-button>

        <div style="margin-top: 20px; width: 100%;">
          <el-table
            ref="multipleTable"
            :data="page.rows"
            tooltip-effect="dark"
            style="margin-top: 0px; width: 100%;"
            border
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column prop="goodsInfo" width="260" show-overflow-tooltip label="商品">
              <template slot-scope="row">
                <el-row>
                  <el-col :span="8">
                    <span>
                      <img
                        style="margin-right:10px;"
                        width="100%"
                        height="44px"
                        :src="row.row.goodsInfo.logo?row.row.goodsInfo.logo:'../../../static/image/noImg.png'"
                      />
                    </span>
                  </el-col>
                  <el-col :span="16">
                    <span
                      style="color:rgb(77, 148, 255);margin-left:10px;"
                    >{{row.row.goodsInfo.name}}</span>
                    <span style="display:block;margin-left:10px;">
                      <span style="color:red">￥{{row.row.goodsInfo.price}}</span>
                      <span
                        style="text-decoration:line-through;color:rgb(162,170,188)"
                      >￥{{row.row.goodsInfo.originalPrice}}</span>
                    </span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column width="100px" prop="goodsInfo.type" label="商品类型"></el-table-column>
            <el-table-column width="160px" prop="goodsInfo.subjectCourseName" label="所属科目"></el-table-column>
            <el-table-column width="100px" prop="goodsInfo.originalPrice" label="原价(元)"></el-table-column>
            <el-table-column prop="goodsInfo.price" label="折后价(元)" align="center">
              <template slot-scope="row">
                <div class="zhao-center" style="justify-content: space-between;">
                  <div
                    class="zhao-center"
                    style="width: 33%;"
                    :style="index<=2?'margin-bottom:10px':''"
                    v-for="(item,index) in row.row.goodsAgentPriceList"
                    :key="index"
                  >
                    <div
                      class="zhao-center"
                      :style="`width:70px;height:24px;color:#fff;background-color: ${item.agentLevel.color}` "
                    >{{item.agentLevel.name}}</div>
                    <div
                      style="margin-left:6px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width:calc(100% - 80px)"
                    >{{item.price}}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop label="操作" width="100" align="center">
              <template slot-scope="scope">
                <div class="operationGroup">
                  <i
                    class="el-icon-edit mainColor"
                    style="font-size:16px"
                    @click="openEdit(scope.row)"
                  ></i>
                  <i
                    class="el-icon-delete mainColor"
                    style="font-size:16px"
                    @click="deleteEdit(scope.row)"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next, jumper,  total, sizes"
            style="margin-top: 20px;text-align: left;"
            :total="page.total"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="添加商品" :visible.sync="addFormVisible" width="60%" left>
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="9" :md="9" :lg="9">
            <!-- <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-select v-model="chapterForm.pid" placeholder="请选择" clearable>
                <el-option v-for="item in pList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="所属科目" label-width="80px" prop="pid">
              <el-cascader
                :show-all-levels="false"
                ref="tree"
                collapse-tags
                @change="subjectChange"
                :options="subjectTreeList"
                :props="subjectTreeProps"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="9" :md="9" :lg="9">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm2.name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="5" :md="5" :lg="5" style="margin-left:10px">
            <el-button type="primary" @click="pageList2">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table
              ref="multipleTables"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              height="400"
              :data="page2.rows"
              tooltip-effect="dark"
              style="width: 100%;"
              @selection-change="selectionChange"
              border
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img
                          style="margin-right:10px;"
                          width="100%"
                          height="44px"
                          :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                        />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      <span style="display:block;margin-left:10px;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span
                          style="text-decoration:line-through;color:rgb(162,170,188)"
                        >￥{{row.row.originalPrice}}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="200" prop="agentPrice" label="售价">
                <template slot-scope="row">
                  <span style="display:block;">
                    <span style="color:red">￥{{row.row.price}}</span>
                    <span
                      style="text-decoration:line-through;color:rgb(162,170,188)"
                    >￥{{row.row.originalPrice}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="开通价">
                <template slot-scope="row">
                  <span style="color:red;font-weight:bold">{{row.row.agentPrice}}</span>
                </template>
              </el-table-column>-->
              <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                <template slot-scope="row">{{row.row.validDay?row.row.validDay+'天':'不限'}}</template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="200"
                prop="subjectCourseName"
                label="所属科目"
              ></el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="60" prop="goodsItemCount" label="内容"></el-table-column> -->
            </el-table>
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 30, 40]"
              style="margin-top: 20px;text-align: right;"
              :total="page2.total"
              :page-size="page2.pageSize"
              :current-page="page2.pageNumber"
              @size-change="sizeChange2"
              @current-change="currentChange2"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑代理价" :visible.sync="editVisible" width="400px" left>
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <div class="zhao-center">
            <div
              style="color: #455A64;font-weight:bold;font-size:14px;width:50%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
            >商品名:{{editForms.goodsInfo.name}}</div>

            <div
              style="color: #455A64;font-weight:bold;font-size:14px;text-align:right;width:50%"
            >商品价格:{{editForms.goodsInfo.price}}</div>
          </div>
        </el-row>
        <el-row :span="24" style="margin:10px 0">
          <el-col :sm="6" :md="6" :lg="6">
            <div>代理等级</div>
          </el-col>

          <el-col :sm="9" :md="9" :lg="9">
            <div>代理价格</div>
          </el-col>
        </el-row>
        <el-row :span="24" v-for="(item,index) in editForms.goodsAgentPriceList" :key="index">
          <div class="zhao-center" style="justify-content: space-between;margin-bottom:10px">
            <div
              class="zhao-center"
              :style="`width:20%;height:32px;color:#fff;background-color: ${item.agentLevel.color}` "
            >{{item.agentLevel.name}}</div>

            <el-input style="width:76%;" size="small" v-model="item.price" placeholder>
              <template slot="append">
                <span class="mainColor">元</span>
              </template>
            </el-input>
          </div>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},

  data() {
    return {
      editForms: {
        goodsInfo: {
          name: "",
          price: ""
        },
        goodsAgentPriceList: [
          {
            price: "",
            agentLevel: {
              name: "",
              discount: 0
            }
          }
        ]
      },
      showSty: "",
      formLabelWidth: "80px",
      inputValue: "",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children"
      },
      page2: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      searchForm2: {
        sell: 1,
        name: "",
        subjectIds: []
      },
      loading: false,
      addFormVisible: false,
      editVisible: false,
      subjectTreeList: [],
      organizations: [],
      subjectListAdd: []
    };
  },
  computed: {
    logindata() {
      return this.$store.state.loginData;
    }
  },
  mounted() {
    this.getAgentInfoList();
    this.pageList();
  },
  methods: {
    closeDialog2() {
      let obj = [];
      this.editForms.goodsAgentPriceList.forEach(item => {
        obj.push({
          id: item.id,
          price: item.price.toString()
        });
      });
      this.api.goodsAgentPrice
        .updateGoodsAgentPriceByBatch(obj)
        .then(result => {
          if (result.success) {
            this.editVisible = false;
            this.pageList();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //删除商品
    deleteEdit(val) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          let obj = [];
          val.goodsAgentPriceList.forEach(item => {
            obj.push({
              id: item.id
            });
          });
          this.api.goodsAgentPrice
            .deleteGoodsAgentPrice(obj)
            .then(result => {
              if (result.success) {
                this.pageList();
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    openEdit(val) {
      this.editVisible = true;
      val.goodsAgentPriceList.forEach(item => {
        item.agentLevel.agentLevel;
      });
      this.editForms = val;
    },
    getAgentInfoList() {
      this.api.agentLevel.getAgentLevelList().then(result => {
        this.organizations = result.data;
      });
    },
    subjectChange(val) {
      if (val) {
        this.searchForm2.subjectIds = [];
        val.forEach(item => {
          this.searchForm2.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm2.subjectIds = [];
      }
    },
    selectionChange(val) {
      this.subjectListAdd = val;
    },
    closeDialog() {
      let arr = [];
      this.subjectListAdd.forEach(item => {
        arr.push(item.id);
      });
      this.api.goodsAgentPrice
        .addGoodsAgentPrice({
          ids: arr
        })
        .then(result => {
          if (result.success) {
            this.loading = false;
            this.addFormVisible = false;
            this.pageList();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateAgentLevel(row) {
      this.api.agentLevel
        .updateAgentLevel(row)
        .then(result => {
          if (result.success) {
            this.showSty = "";
            this.$message({
              type: "success",
              message: result.message
            });
            this.editFormVisible = false;
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    settingEvent(event) {
      event.stopPropagation();
    },
    normalEvent() {
      this.showSty = "";
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
      this.pageList2();
    },
    currentChange2(pageNumber) {
      this.page2.pageNumber = pageNumber;
      this.pageList2();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList2() {
      this.loading = true;
      let obj = {};
      this.searchForm2.pageSize = this.page2.pageSize;
      this.searchForm2.pageNumber = this.page2.pageNumber;
      this.searchForm2.sortName = this.page2.sortName;
      this.searchForm2.sortOrder = this.page2.sortOrder;
      this.api.goodsInfo
        .pageList(this.searchForm2)
        .then(result => {
          this.loading = false;
          this.page2.rows = result.data.records;
          this.page2.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    openaddFormVisible() {
      this.addFormVisible = true;
      this.pageList2();
      this.api
        .getSubjectTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      let obj = {};
      obj.pageNumber = this.page.pageNumber;
      obj.sortName = this.page.sortName;
      obj.sortOrder = this.page.sortOrder;
      obj.pageSize = this.page.pageSize;
      this.api.goodsAgentPrice
        .pageList(obj)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          for (let i in this.page.rows) {
            if (this.page.rows[i].enabled == 1) {
              this.page.rows[i].enabled = true;
            } else {
              this.page.rows[i].enabled = false;
            }
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script> 

<style scoped lang="less" >
.goodsAgentPrice {
  background: #fff;
  padding: 0 20px;
  .agent-goods {
    padding: 20px 0;
    .agent-goods-title {
      font-size: 16px;
      color: #455a64;
      padding-bottom: 20px;
    }
  }
  .agent-price {
    border-bottom: 1px rgba(238, 238, 238, 1) solid;
    padding: 20px 0 0 0;
    .agent-price-edit {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      .agent-price-edit-item {
        margin-right: 20px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .title {
          width: 70px;
          height: 32px;
          background-color: rgba(255, 177, 2, 1);
          color: #fff;
          text-align: center;
          line-height: 32px;
          font-size: 13px;
        }
        .edit {
          float: right;
          line-height: 32px;
          margin-right: 10px;
          display: none;
          font-size: 16px;
        }
        .show {
          border: 1px solid rgba(238, 238, 238, 1);
          line-height: 32px;
          width: 70px;
          height: 32px;
          padding-left: 6px;
          box-sizing: border-box;
          color: #455a64;
        }
      }
      .agent-price-edit-item:hover {
        .edit {
          display: inline-block;
        }
      }
    }
    .agent-price-title {
      font-size: 16px;
      color: #455a64;
      padding-bottom: 20px;
    }
  }
  .agent-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    color: #455a64;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px rgba(238, 238, 238, 1) solid;
    div {
      font-size: 16px;
    }
  }
}
</style>

<style >
.goodsAgentPrice .agent-price .el-input__inner {
  width: 100px !important;
  height: 32px !important;
  border: 1px solid #409eff;
  border-radius: 0px !important;
  border-right: 0px !important;
}
.goodsAgentPrice .agent-price .el-input {
  width: 160px !important;
}
.goodsAgentPrice .agent-price .el-input-group__append {
  background: #ffffff !important;
  border: 1px solid #409eff;
  width: 60px !important;
  border-radius: 0px !important;
  border-left: 0px !important;
  padding: 0px !important;
}
.zhao-center .el-input__inner,
.el-input-group__append {
  border-radius: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/goodsAgentPrice/goodsAgentPrice.vue